// @flow

import { useDispatch } from 'react-redux';

import { getCart, selectCartIsReopenable, selectCartUUID } from '@gandi/cart';
import { useTranslator } from '@gandi/translate';
import { Button, Svg } from '@gandi/ui';

import { useAppSelector } from 'src/hooks/useAppSelector';
import { tryResumeCart } from 'src/modules/app/actions';

import { Breadcrumb, type BreadCrumbProps } from '../Breadcrumb/Breadcrumb';

import styles from './FunnelControls.scss';

type Props = {
  currentStep: BreadCrumbProps['currentStep'],
};

export function FunnelControls({ currentStep }: Props): React.MixedElement {
  const { __ } = useTranslator();
  const dispatch = useDispatch();

  // after the paiement the cart is emptied
  const cartId = useAppSelector(selectCartUUID);
  // cart is cartIsReopenable tell us is the status is closed
  const cartIsReopenable = useAppSelector(selectCartIsReopenable);

  const onClickHandler = async () => {
    // to avoid to reopen a cart that should not be
    // we check first if we have a cart via cartId
    // then if the current status make it reopenable
    // so we fetch it, that will update the status
    // and we try to resume it
    if (!!cartId && cartIsReopenable)
      await dispatch(getCart()).then(() => dispatch(tryResumeCart()));
  };

  return (
    <>
      <Button onClick={onClickHandler} to="/" className={styles.logoContainer}>
        <Svg
          // needed for the display title
          id="gandi-net-logo"
          name="gandiIcon"
          theme="neutral-strong"
          title={__('Return to homepage')}
          className={styles.logo}
        />
      </Button>
      <Breadcrumb currentStep={currentStep} />
    </>
  );
}
